import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension'; // Updated import
import rootReducer from './reducers';

// composeWithDevTools will automatically apply Redux Thunk if it's installed and passed,
// but for now, we are not using thunks explicitly.
const composedEnhancers = composeWithDevTools(
  applyMiddleware() // No middleware applied yet, but can be added here e.g. thunk
  // other store enhancers if any
);

const store = createStore(
  rootReducer,
  composedEnhancers
);

export default store;
